<template>
  <div class="card-wrapper" v-if="checkPermission(['chartView_list_grade_and_class'])">
    <div class="card-header">
      <div class="card-heading">
        <div class="card-icon">
          <i class="el-icon-s-grid"></i>
        </div>
        <div>
          <p class="card-title">Danh sách diểm danh</p>
          <p class="card-subtitle">Tổng hợp điểm danh theo từng lớp</p>
        </div>
      </div>
      <el-button type="text" class="toggle-button" @click="toggleTableVisible">
        {{ isTableVisible ? "Ẩn bảng" : "Hiện bảng" }}
      </el-button>
    </div>

    <div class="card-content" v-show="isTableVisible" v-loading="isLoading">
      <el-table
        :data="responseDataList"
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :max-height="$tableMaxHeight"
        border
      >
        <el-table-column type="index" label="STT" width="50" align="center"></el-table-column>
        <el-table-column min-width="120px" prop="className" label="Lớp"></el-table-column>
        <el-table-column min-width="110px" prop="gradeName" label="Khối"></el-table-column>
        <el-table-column width="130px" prop="kidsTotalNumber" label="Tổng số HS" align="center"></el-table-column>
        <el-table-column prop="attendanceYes" label="Đã điểm danh" min-width="130px" align="center"></el-table-column>
        <el-table-column prop="attendanceNo" label="Chưa điểm danh" min-width="130px" align="center"></el-table-column>
        <el-table-column prop="goSchoolNumber" label="Đi học" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="absentNumber" label="Nghỉ học" min-width="100px" align="center"></el-table-column>
        <el-table-column prop="leaveYes" min-width="100px" label="Đã về" align="center"></el-table-column>
        <el-table-column prop="leaveNo" min-width="100px" label="Chưa về" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import DashboardService from "@/services/DashboardService";
import checkPermission from "@/utils/permission";

export default {
  name: "ClassAttendanceTableCard",
  data() {
    return {
      responseDataList: [],
      isLoading: false,
      isTableVisible: false,
    };
  },
  async mounted() {
    await this.getDataInitialInClass();
  },
  methods: {
    checkPermission,
    toggleTableVisible() {
      this.isTableVisible = !this.isTableVisible;
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },
    async getDataInitialInClass() {
      this.isLoading = true;
      try {
        const resp = await DashboardService.getStatisticalInClass();
        this.responseDataList = resp.data.data || [];
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-wrapper {
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  border-radius: 24px;
  box-shadow: 0 18px 40px rgba(31, 45, 61, 0.08);
  padding: 20px;
  margin: 20px 0;
  border: 1px solid rgba(122, 147, 184, 0.12);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.toggle-button {
  font-weight: 600;
  color: #4f8dfd;
  padding: 0;
}

.card-heading {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #ffffff;
  background: linear-gradient(135deg, #4f8dfd, #36cfc9);
  box-shadow: 0 14px 24px rgba(79, 141, 253, 0.24);
}

.card-title {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #22324d;
}

.card-subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: #7f8da3;
}

.card-content {
  border-radius: 20px;
  border: 1px solid rgba(118, 153, 214, 0.14);
  padding: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.card-content::v-deep .el-table {
  border-radius: 10px;
  overflow: hidden;
}
</style>

